const requireModule = require.context('./modules', true, /routes\.js$/)
const routes = []

requireModule.keys().forEach(componentFilePath => {
  const route = requireModule(componentFilePath).default
  if (route) {
    routes.push(route)
  }
})

export default [].concat(
  [
    {
      path: '/403',
      meta: {
        public: true
      },
      name: 'AccessDenied',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/Deny.vue`)
    },
    {
      path: '/500',
      meta: {
        public: true
      },
      name: 'ServerError',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/Error.vue`)
    },
    {
      path: '/login',
      meta: {
        public: true
      },
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/Login.vue`)
    },
    {
      path: '/forgot-password',
      meta: {
        public: true
      },
      name: 'ForgotPassword',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/ForgotPassword.vue`)
    },
    {
      path: '/password-reset/:token',
      meta: {
        public: true
      },
      name: 'PasswordReset',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/PasswordReset.vue`)
    },
    {
      path: '/setup',
      meta: {
        public: true
      },
      name: 'Setup',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/Setup.vue`)
    },
    {
      path: '/media',
      name: 'Media',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/Media.vue`)
    },
    {
      path: '*',
      meta: {
        public: true
      },
      name: 'NotFound',
      component: () =>
        import(/* webpackChunkName: "routes" */
          /* webpackMode: "lazy" */
          `@/views/NotFound.vue`)
    }
  ],
  ...routes
)
